import React, { Component } from 'react'
import PopupWindow from './PopupWindow'
import { connect } from 'react-redux';
import * as StatisticActions from '../../actions/statisticActions';
import * as GameActions from '../../actions/gameActions';
import { bindActionCreators } from 'redux';
import Checkbox from './Checkbox'
import StatsBaseWindow from './StatsBaseWindow'
import * as summaryEventTypes from '../../constants/SummaryEventTypes'
import { MOVE_TO_EVENT } from '../../actions/gameActions'

class SummaryWindow extends StatsBaseWindow {

    static propTypes = {
        top: React.PropTypes.number,
        left: React.PropTypes.number
    }

    static defaultProps = {
        top: 10,
        left: 10
    }

    constructor(props) {
        super(props);
    }

    getPlayerById(id) {
        for (let index = 0; index < this.props.Players.length; index++) {
            let player = this.props.Players[index];
            if(player.Id == id)
                return player;
        }

        return null;
    }

    get homeEvents() {
        let result = [];
        this.props.EventList.forEach((event) => {
            if(event.team == 1)
                result.push(event);
        });

        return result;
    }

    get awayEvents() {
        let result = [];
        this.props.EventList.forEach((event) => {
            if(event.team != 1)
                result.push(event);
        });
        
        return result;
    }

    onEventClick(event){
        this.props.GameActions.MOVE_TO_EVENT(Math.max(1, event.event-9));
    }

    renderEvent(event) {
        switch(event.type) {
            case summaryEventTypes.Goal:
                return (<div onClick={() => this.onEventClick(event)} key={event.num} className="row">
                            <div className="col-md-2 col-sm-2">
                                <div className="goal-icon"></div>
                            </div>
                            <div className="col-md-10 col-sm-10 event-row">{this.getPlayerById(event.playerId).Name.LastName} ({event.minute}{event.penalty == true ? ", пен" : ""})</div>
                        </div>)
                break;
            case summaryEventTypes.OwnGoal:
                return (<div onClick={() => this.onEventClick(event)} key={event.num} className="row">
                            <div className="col-md-2 col-sm-2">
                                <div className="goal-icon"></div>
                            </div>
                            <div className="col-md-10 col-sm-10 event-row">{this.getPlayerById(event.playerId).Name.LastName} (а) ({event.minute})</div>
                        </div>)
                break;
            case summaryEventTypes.RedCard:
                    return (<div onClick={() => this.onEventClick(event)} key={event.num} className="row">
                                <div className="col-md-2 col-sm-2">
                                    <div className="red-card-icon"></div>
                                </div>
                                <div className="col-md-10 col-sm-10 event-row">{this.getPlayerById(event.playerId).Name.LastName} ({event.minute})</div>
                            </div>)
                break;
            default:
                throw 'Unknown event type: ' + event.type
                break;
        }
    }
    render() {
        const { close_stats_window } = this.props.StatisticActions;

        /*
                    <div className="row">
                        <div className="col-md-12 col-sm-12">
                            <img src="https://pefl.ru/system/img/w0.png"/><span>09 Октября, 2017 </span><br/>
                        </div>
                    </div>
        */

        return (<PopupWindow header="Обзор матча" is_cut_down={this.props.is_cut_down} onDragStop={this.onDragStop.bind(this)} onToggleCutDown={this.onToggleCutDown.bind(this)} top={this.position.top}  left={this.position.left} onClose={() => (close_stats_window(this.props.id))}>
                    <div className="row summary">
                        <div className="col-md-6 col-sm-6">
                            <div className="row header">
                                <div className="col-md-10 col-sm-10">
                                    {this.props.HomeTeamName}
                                </div>
                                <div className="col-md-2 col-sm-2">
                                    {this.props.HomeScore}
                                </div>
                            </div>
                            {this.homeEvents.map((event) => this.renderEvent(event))}
                        </div>
                        <div className="col-md-6 col-sm-6">
                            <div className="row header">
                                <div className="col-md-10 col-sm-10">
                                    {this.props.AwayTeamName}
                                </div>
                                <div className="col-md-2 col-sm-2">
                                    {this.props.AwayScore}
                                </div>
                            </div>
                            {this.awayEvents.map((event) => this.renderEvent(event))}
                        </div>
                    </div>
                </PopupWindow>)
    }
}

function mapStateToProps(state, ownProps) {
    return {
        position: state.statisticWindows[ownProps.id].position,
        is_cut_down: state.statisticWindows[ownProps.id].is_cut_down,
        HomeTeamName: state.HomeTeam.Name,
        AwayTeamName: state.AwayTeam.Name,
        HomeScore: state.Stats.Score.Home,
        AwayScore: state.Stats.Score.Away,
        Players: state.HomeTeam.Players.concat(state.AwayTeam.Players),
        EventList: state.Stats.EventList
    };
}

function mapDispatchToProps(dispatch) {
    return {
        StatisticActions: bindActionCreators(StatisticActions, dispatch),
        GameActions: bindActionCreators(GameActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SummaryWindow)



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/SummaryWindow.js
 **/